module.exports = __webpack_public_path__ + "static/media/circle-culture.e9071912.svg";